export default (element: HTMLElement) => {
  const closeButton = element.querySelector<HTMLButtonElement>(
    '[data-guide-close-button]',
  );
  if (!closeButton) return;

  // Get unique guide ID from data attribute, fallback to default
  const guideId = element.dataset.guideId || 'defaultGuide';
  const storageKey = `guideHidden_${guideId}`;

  // Check localStorage for guide visibility state
  const isHidden = localStorage.getItem(storageKey) === 'true';

  if (isHidden) {
    element.classList.add('guide--closed');
  }

  closeButton.addEventListener('click', () => {
    const isNowHidden = element.classList.toggle('guide--closed');
    localStorage.setItem(storageKey, isNowHidden ? 'true' : 'false');
  });
};
